<template>
  <v-dialog v-model="dialogBundlePackage" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{isChinessLanguage ? '包装' : 'Đóng bao hàng'}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3>
          <!-- Left Column: Input Section -->
          <v-flex lg3 md12 sm12>
            <v-layout row wrap pa-3>
              <!-- SECTION 1: Nhập kho -->
              <v-flex lg12 md12 sm12 xs12>
                <v-card outlined class="mb-4">
                  <v-card-title class="subtitle-1 primary white--text">
                    {{isChinessLanguage ? '入仓信息' : 'THÔNG TIN NHẬP KHO'}}
                  </v-card-title>
                  <v-card-text>
                    <!-- Customer Selection -->
                    <v-flex lg12 md12 sm12 xs12 pa-0 v-if="!selectedCustomerID">
                      <v-autocomplete 
                        class="input-group--focused" 
                        append-icon='' 
                        clearable 
                        :label="isChinessLanguage ? '代理' : 'Khách hàng'" 
                        v-model="packageInfo.UID" 
                        :items="customers" 
                        item-text="CustomerCode" 
                        item-value="ID"
                      ></v-autocomplete>
                    </v-flex>

                    <!-- Shipment Code Input -->
                    <v-flex lg12 md12 sm12 xs12 pa-0>
                      <v-text-field
                        :label="isChinessLanguage ? '入单号(enter)' : 'Nhập mã bill (enter)'"
                        ref="trancode"
                        v-model="shipmentCode"
                        class="input-group--focused"
                        :rules="requireRules"
                        @keyup.enter="addShipmentToList"
                      ></v-text-field>
                    </v-flex>

                    <!-- Weight Input -->
                    <v-flex lg12 md12 sm12 xs12 pa-0>
                      <h-currency-input
                        v-model="currentShipment.ChinaWeight"
                        :decimal="2"
                        :label="isChinessLanguage ? '重量' : 'Cân nặng'"
                        class="input-group--focused"
                        @press_enter="focusNext"
                      ></h-currency-input>
                    </v-flex>

                    <!-- Quantity Input -->
                    <v-flex lg12 md12 sm12 xs12 pa-0>
                      <h-currency-input
                        v-model="currentShipment.RealNumberOfPack"
                        :decimal="0"
                        :label="isChinessLanguage ? '数量' : 'Số lượng'"
                        class="input-group--focused"
                        @press_enter="focusNext"
                      ></h-currency-input>
                    </v-flex>

                    <!-- Product Name Input -->
                    <v-flex lg12 md12 sm12 xs12 pa-0>
                      <v-text-field
                        :label="isChinessLanguage ? '商品名称' : 'Tên hàng hóa'"
                        v-model="currentShipment.ProductName"
                        class="input-group--focused"
                        @keyup.enter="addToWarehouseOnly"
                      ></v-text-field>
                    </v-flex>

                    <!-- Warehouse Action Button -->
                    <v-flex lg12 md12 sm12 xs12 pa-0 mt-2>
                      <v-btn @click="addToWarehouseOnly" color="primary" block>
                        {{isChinessLanguage ? '入仓' : 'Nhập kho'}}
                      </v-btn>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>

              <!-- SECTION 2: Đóng bao -->
              <v-flex lg12 md12 sm12 xs12>
                <v-card outlined>
                  <v-card-title class="subtitle-1 success white--text">
                    {{isChinessLanguage ? '包装信息' : 'THÔNG TIN ĐÓNG BAO'}}
                  </v-card-title>
                  <v-card-text>
                    <!-- Package Code Input -->
                    <v-flex lg12 md12 sm12 xs12 pa-0>
                      <v-text-field
                        :label="isChinessLanguage ? '包裹编号' : 'Ghi chú bao hàng'"
                        v-model="packageInfo.PackageCode"
                        class="input-group--focused"
                      ></v-text-field>
                    </v-flex>

                    <!-- Real Weight Input -->
                    <!-- <v-flex lg12 md12 sm12 xs12 pa-0>
                      <h-currency-input
                        v-model="packageInfo.RealWeight"
                        :decimal="2"
                        :label="isChinessLanguage ? '实际重量' : 'Cân thực tế'"
                        class="input-group--focused"
                      ></h-currency-input>
                    </v-flex> -->

                    <!-- Bundle Action Button -->
                    <v-flex lg12 md12 sm12 xs12 pa-0 mt-2>
                      <v-btn @click="createBundlePackage" color="success" block :disabled="shipmentList.length === 0">
                        {{isChinessLanguage ? '打包' : 'Đóng bao'}}
                      </v-btn>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- Right Column: Shipment List Table -->
          <v-flex lg9 md12 sm12>
            <v-layout pl-4 pr-2 pt-12>
              <v-flex lg12 md12 sm12 xs12>
                <v-data-table
                  :headers="headers"
                  :items="shipmentList"
                  :options.sync="pagination"
                  :server-items-length="total_rows"
                  :footer-props="items_per_page"
                  :loading="loading"
                  :mobile-breakpoint="100"
                >
                  <template v-slot:[`body.prepend`]>
                    <tr class="grey lighten-4">
                      <td colspan="3" class="font-weight-bold">{{ isChinessLanguage ? '总计' : 'Tổng cộng' }}</td>
                      <td class="text-end font-weight-bold">{{ summaryTotals.ChinaWeight | currency('', 2) }}</td>
                      <td class="text-end font-weight-bold">{{ summaryTotals.RealNumberOfPack | currency }}</td>
                      <td></td>
                      <td></td>
                    </tr>
                  </template>
                  <template v-slot:item="{ item, index }">
                    <tr>
                      <td>{{ index + 1 }}</td>
                      <td>{{ getCustomerName(item.UID) }}</td>
                      <td>{{ item.TransactionCode }}</td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.ChinaWeight"
                          large
                          lazy
                          persistent
                          @save="updateShipmentItem({ID: item.ID, ChinaWeight: item.ChinaWeight})"
                        >
                          <div>{{ item.ChinaWeight | currency('', 2)}}</div>
                          <template v-slot:input>
                            <v-text-field
                              v-model="item.ChinaWeight"
                              type="number"
                              step=".1"
                              :label="isChinessLanguage ? '重量' : 'Cân nặng'"
                              single-line
                              autofocus
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.RealNumberOfPack"
                          large
                          lazy
                          persistent
                          @save="updateShipmentItem({ID: item.ID, RealNumberOfPack: item.RealNumberOfPack})"
                        >
                          <div>{{ item.RealNumberOfPack | currency }}</div>
                          <template v-slot:input>
                            <v-text-field
                              v-model="item.RealNumberOfPack"
                              type="number"
                              step="1"
                              :label="isChinessLanguage ? '数量' : 'Số lượng'"
                              single-line
                              autofocus
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td>
                        <v-edit-dialog
                          :return-value.sync="item.ProductName"
                          large
                          lazy
                          persistent
                          @save="updateShipmentItem({ID: item.ID, ProductName: item.ProductName})"
                        >
                          <v-tooltip top right max-width="250">
                            <template v-slot:activator="{ on }">
                              <span v-on="on">{{ item.ProductName }}</span>
                            </template>
                            <span>{{ item.ProductName }}</span>
                          </v-tooltip>
                          <template v-slot:input>
                            <v-text-field
                              v-model="item.ProductName"
                              :label="isChinessLanguage ? '商品名称' : 'Tên hàng'"
                              single-line
                              autofocus
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-center">
                        <v-icon small v-bind:style="{ 'color': item.Packages && item.Packages.length > 0 ? '#dc3545' : 'gray'}" @click="duplicateItem(item.ID)">widgets</v-icon>
                        <v-icon small color="#dc3545" @click="printTransaction(item)">fa-print</v-icon>
                        <v-icon small @click="removeShipmentItem(index)">fa-trash-alt</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <split-package
            :dialogSplitPackage="innerDialog"
            :currentItem="currentItem"
            v-on:closePopup="innerDialog = false"
      ></split-package>
      <v-overlay :value="appLoading" z-index="99999999">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import { sendErrorNotice, sendSuccessNotice, getCurrentTime } from "@/commons/utils";
import { request_detail, request_list, print_transaction_v2 } from "@/commons/hpod";
import split_package from "@/components/popups/split_package";
import Vue from 'vue';

export default {
  name: "bundle-package-popup",
  components: {
    "split-package": split_package
  },
  data() {
    return {
      innerDialog: false,
      appLoading: false,
      shipmentCode: '',
      summaryTotals: {
        ChinaWeight: 0,
        RealNumberOfPack: 0
      },
      currentShipment: {
        ChinaWeight: 0,
        RealNumberOfPack: 1,
        ProductName: ''
      },
      packageInfo: {
        UID: 0,
        PackageCode: '',
        RealWeight: 0,
        Note: ''
      },
      uniqueId: Date.now().toString(36) + Math.random().toString(36).substring(2),
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: { ...configs.PAGINATION, sortBy: ["StoreCNImportDate"] },
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE)
    };
  },
  props: ["dialogBundlePackage"],
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        this.getListData();
      },
      deep: true
    },
    dialogBundlePackage() {
      if (this.dialogBundlePackage) {
        this.uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2);
        this.resetDialog();
        this.getListData();
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    }
  },
  computed: {
    ...mapState({
      customers: state => state.customer.master.data,
      shipmentList: state => state.orderTransaction.listOfDay.data,
      total_rows: state => state.orderTransaction.listOfDay.total,
      currentItem: state => state.orderTransaction.selected,
      loading: state => state.orderTransaction.loading
    }),
    isChinessLanguage() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ && this.$store.state.authentication.user.ischinesslanguage;
    },
    chinaStoreID() {
      return this.$store.state.authentication.user.chinastoreid;
    },
    selectedCustomerID() {
      return this.$store.state.authentication.user.customerid;
    },
    filterData() {
      return [
        {
          column: "GUID",
          value: this.uniqueId,
          condition: "s_equal"
        },
        {
          column: "Status",
          value: configs.PACKAGE_STATUS_ENUM.DA_VE_TQ,
          condition: "equal"
        }
      ];
    },
    headers() {
      return [
        {
          text: this.isChinessLanguage ? "No." : "STT",
          value: "",
          sortable: false
        },
        {
          text: this.isChinessLanguage ? "代理" : "Khách hàng",
          value: "UID"
        },
        {
          text: this.isChinessLanguage ? "单号" : "Mã bill",
          value: "TransactionCode"
        },
        {
          text: this.isChinessLanguage ? "Kg" : "Kg",
          value: "ChinaWeight",
          align: "end"
        },
        {
          text: this.isChinessLanguage ? "数量" : "Số lượng",
          value: "RealNumberOfPack",
          align: "end"
        },
        {
          text: this.isChinessLanguage ? "商品名称" : "Tên hàng",
          value: "ProductName"
        },
        {
          text: this.isChinessLanguage ? "操作" : "Thao tác",
          value: "",
          align: "center",
          sortable: false
        }
      ];
    }
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    buildBundleFilter() {
      const filter = [...this.filterData];
      if (this.chinaStoreID) {
        filter.push({
          column: "ChinaStoreID",
          value: this.chinaStoreID,
          condition: "equal"
        });
      }
      return filter;
    },
    getSummaryTotals() {
      request_list("order_transactions", ret => {
        const items = _.get(ret, "data", []);
        this.summaryTotals = {
          ChinaWeight: _.sumBy(items, item => Number(item.ChinaWeight) || 0),
          RealNumberOfPack: _.sumBy(items, item => Number(item.RealNumberOfPack) || 0)
        };
      }, Vue.http, {
        filter: this.buildBundleFilter(),
        quickFilter: []
      }, this.$store.state.authentication.token);
    },
    focusNext(e) {
      const inputs = Array.from(e.target.ownerDocument.querySelectorAll('.input-group--focused input:not([type=hidden])'));
      const index = inputs.indexOf(e.target);
      if (index < inputs.length - 1) {
        inputs[index + 1].focus();
      }
      else {
        // When reaching the last input in warehouse section, trigger add to warehouse
        this.addToWarehouseOnly();
      }
    },
    getCustomerName(uid) {
      const cus = _.find(this.customers, {ID: uid});
      return cus ? cus.CustomerCode : '';
    },
    resetDialog() {
      this.shipmentCode = '';
      this.currentShipment = {
        ChinaWeight: 0,
        RealNumberOfPack: 1,
        ProductName: ''
      };
      this.packageInfo = {
        UID: 0,
        PackageCode: '',
        RealWeight: 0,
        Note: ''
      };
      this.summaryTotals = {
        ChinaWeight: 0,
        RealNumberOfPack: 0
      };
    },
    getListData() {
      const filter_param = {
        pagination: this.pagination,
        filter: this.buildBundleFilter(),
        quickFilter: []
      };
      this.$store.dispatch("orderTransaction/getListOfDay", filter_param);
      this.getSummaryTotals();
    },
    addShipmentToList: _.debounce(
      function() {
        if (this.shipmentCode.trim() === '') {
          sendErrorNotice(this.isChinessLanguage ? '请输入运单号' : 'Vui lòng nhập mã bill');
          return;
        }

        // Check if shipment code already exists in current session list
        const exists = _.find(this.shipmentList, { TransactionCode: this.shipmentCode });
        if (exists) {
          sendErrorNotice(this.isChinessLanguage ? '运单号已存在于列表中' : 'Mã bill đã có trong danh sách');
          this.shipmentCode = '';
          this.$nextTick(() => this.$refs.trancode.focus());
          return;
        }

        this.appLoading = true;
        
        // Call API to check if shipment exists in system (logic nhập kho ban đầu)
        request_detail('order_transactions', ret => {
          this.appLoading = false;
          let item = ret.data;
          
          if (item && item.ID) {
            // Bill already exists in system - show error
            sendErrorNotice(this.isChinessLanguage ? '运单号已存在于系统中' : 'Mã vận đơn đã tồn tại trong hệ thống');
            this.shipmentCode = '';
            this.$nextTick(() => this.$refs.trancode.focus());
          } else {
            // Bill does not exist - create new entry and warehouse immediately (tham khảo store.vue appendTransactionCode)
            let payLoad = {
              GUID: this.uniqueId,
              TransactionCode: this.shipmentCode,
              ChinaWeight: this.currentShipment.ChinaWeight || 0,
              RealNumberOfPack: this.currentShipment.RealNumberOfPack || 1,
              ProductName: this.currentShipment.ProductName || '',
              Status: configs.PACKAGE_STATUS_ENUM.DA_VE_TQ,
              TransactionView: 'store_cn_popup',
              ChinaStoreID: this.chinaStoreID
            };
            
            if (this.selectedCustomerID) {
              payLoad.UID = this.selectedCustomerID;
              payLoad.Username = this.getCustomerName(this.selectedCustomerID);
            } else if (this.packageInfo.UID > 0) {
              payLoad.UID = this.packageInfo.UID;
              payLoad.Username = this.getCustomerName(this.packageInfo.UID);
            }

            const filter_param = {
              pagination: this.pagination,
              filter: this.buildBundleFilter(),
              quickFilter: []
            };

            // Create new bill and warehouse immediately
            this.$store.dispatch("orderTransaction/setDetail", {
              data: payLoad,
              id: 0, // Create new
              param: filter_param,
              ignore_commit: true
            }).then(() => {
              this.getSummaryTotals();
            });

            sendSuccessNotice(this.isChinessLanguage ? '添加成功' : 'Thêm vào danh sách thành công');

            // Reset current shipment data
            this.currentShipment = {
              ChinaWeight: 0,
              RealNumberOfPack: 1,
              ProductName: ''
            };
            this.shipmentCode = '';
            this.$nextTick(() => this.$refs.trancode.focus());
          }
        }, Vue.http, '', this.$store.state.authentication.token, {
          'transaction_code': this.shipmentCode
        });
      },
      300,
      {
        leading: false,
        trailing: true
      }
    ),
    addToWarehouseOnly() {
      // Simply call addShipmentToList to add to warehouse
      this.addShipmentToList();
    },
    updateShipmentItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: item,
        id: item.ID
      }).then(() => {
        this.getSummaryTotals();
      });
    },
    removeShipmentItem(index) {
      const item = this.shipmentList[index];
      // Delete from system via parent component event
      this.$emit("deleteItem", item.ID);
    },
    printTransaction(item) {
      this.appLoading = true;
      request_detail('order_transactions/print', ret => {
        let transItem = ret.data;
        this.appLoading = false;
        const frame_printing = print_transaction_v2(
          transItem, 
          this.$store.state.authentication.user.username, 
          true, 
          null, 
          transItem.Packages != null
        );
        var doc = document.getElementById('print_frame').contentWindow.document;
        doc.open();
        doc.write(frame_printing);
        doc.close();
        setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
      }, Vue.http, item.ID, this.$store.state.authentication.token);
    },
    createBundlePackage() {
      if (this.shipmentList.length === 0) {
        sendErrorNotice(this.isChinessLanguage ? '请添加至少一个运单' : 'Vui lòng thêm ít nhất một mã bill');
        return;
      }

      if (!this.packageInfo.PackageCode || this.packageInfo.PackageCode.trim() === '') {
        sendErrorNotice(this.isChinessLanguage ? '请输入包裹编号' : 'Vui lòng nhập ghi chú bao hàng');
        return;
      }

      this.appLoading = true;

      // Prepare package data (tham khảo big_package.vue saveItem)
      const packageData = {
        PackageCode: this.packageInfo.PackageCode,
        UID: this.selectedCustomerID ? this.selectedCustomerID : (this.packageInfo.UID ? this.packageInfo.UID : (this.shipmentList[0] ? this.shipmentList[0].UID : 0)),
        RealWeight: this.packageInfo.RealWeight || _.sumBy(this.shipmentList, 'ChinaWeight'),
        Weight: _.sumBy(this.shipmentList, 'ChinaWeight'),
        NumberOfPack: this.shipmentList.length,
        Volume: this.shipmentList.length,
        Amount: _.sumBy(this.shipmentList, 'ChinaFeeShip'),
        Status: configs.BIG_PACKAGE_STATUS_ENUM.DANG_DONG_BAO,
        ChinaStoreID: this.chinaStoreID,
        Packages: _.map(this.shipmentList, "ID") // Array of transaction IDs (tham khảo big_package.vue)
      };

      // Dispatch action to create big package (tham khảo big_package.vue saveItem)
      this.$store.dispatch("bigPackage/setDetail", {
        data: packageData,
        id: 0 // Create new package
      });

      // Wait for API call to complete, then reset (tham khảo big_package.vue saveItem isClose=true)
      setTimeout(() => {
        this.appLoading = false;
        sendSuccessNotice(this.isChinessLanguage ? '创建包裹成功' : 'Đóng bao thành công');
        
        // Generate new session GUID and reset for next bundle
        this.uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2);
        this.resetDialog();
        this.getListData();
        this.$nextTick(() => this.$refs.trancode.focus());
        this.$root.$emit("REQUEST_REFRESH_DATA");
      }, 1000);
    },
    duplicateItem(id) {
      this.selectedID = id;
      this.$store.dispatch("orderTransaction/getDetail", id);
      this.innerDialog = true;
    },
  },
  mounted() {
    this.$store.dispatch("customer/getCustomerList", {
      is_master: 1,
      fields: ["ID", "Username", "CustomerCode"]
    });
    this.$root.$on("REQUEST_REFRESH_DATA", this.getListData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.getListData);
  }
};
</script>

<style scoped>
.subtitle-1 {
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}
</style>
